import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
} from '@mui/material';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default function SelectPlan({ planDetails, handleSetPlanDetails }) {
  // Initialize a state variable to keep track of checked checkboxes
  // const [checkedState, setCheckedState] = useState(Array(3).fill(false));
  const planList = [
    'Sparcle Marsterpiece',
    'Sparcle Marsterpiece + RFID',
    'Sparcle Marsterpiece + Third Party software',
  ];
  const [checkedState, setCheckedState] = useState(
    planList.map((plan) => planDetails.Plan.includes(plan))
  );

  // Handler to toggle the checked state
  // const handleOnChange = (position) => {
  //   // Update the checked state based on the position of the checkbox clicked
  //   const updatedCheckedState = checkedState.map((item, index) =>
  //     index === position ? !item : item
  //   );

  //   setCheckedState(updatedCheckedState);
  // };
  // useEffect(() => {
  //   if (checkedState.includes(true)) {
  //     const planNames = handleSetPlanDetails({
  //       Plan: `${checkedState}`,
  //       AllOk: true,
  //     });
  //   } else {
  //     handleSetPlanDetails({
  //       Plan: `${checkedState}`,
  //       AllOk: false,
  //       EcommerceUrl: '',
  //     });
  //   }
  // }, [checkedState]);
  // console.log(checkedState, 'checkedState');
  // console.log(checkedState[5], 'checkedState[6');

  useEffect(() => {
    setCheckedState(planList.map((plan) => planDetails.Plan.includes(plan)));
  }, [planDetails.Plan]);

  // // Handler to toggle the checked state
  // const handleOnChange = (position) => {
  //   const updatedCheckedState = checkedState.map((item, index) =>
  //     index === position ? !item : item
  //   );
  //   setCheckedState(updatedCheckedState);
  // };

  // function handleOnChange() updated due to hold the previuosly selected plan after clicking on the next button and back button changes made by Dnyaneshwar on 31Jan2025
  const handleOnChange = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    setCheckedState(updatedCheckedState);

    const selectedPlans = updatedCheckedState
      .map((isChecked, index) => (isChecked ? planList[index] : null))
      .filter(Boolean);

    handleSetPlanDetails({
      Plan: selectedPlans,
      AllOk: selectedPlans.length > 0,
      EcommerceUrl:
        selectedPlans.length > 0 && updatedCheckedState[2]
          ? planDetails.EcommerceUrl
          : '',
    });
  };

  useEffect(() => {
    const selectedPlans = checkedState
      .map((isChecked, index) => (isChecked ? planList[index] : null))
      .filter(Boolean);
    handleSetPlanDetails({
      Plan: selectedPlans,
      AllOk: selectedPlans.length > 0,
      EcommerceUrl:
        selectedPlans.length > 0 && checkedState[2]
          ? planDetails.EcommerceUrl
          : '',
    });
  }, [checkedState]);

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Plan Select
      </Typography>
      <Grid
        container
        spacing={{ xs: 3, md: 3 }}
        columns={{ xs: 8, sm: 4, md: 12 }}
        style={{ display: 'flex', alignItems: 'center', marginLeft: '100px' }} // Flexbox properties
      >
        {checkedState.map((item, index) => (
          <Grid
            item
            xs={2}
            sm={4}
            md={4.5}
            key={index}
            style={{ display: 'flex', height: '150px', width: '150px' }}
          >
            <Item>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={item}
                      onChange={() => handleOnChange(index)}
                    />
                  }
                  label={planList[index]} //// code updated by Dnyaneshwar on 29/01/2025 for selection of Plan by user
                />
              </FormGroup>
            </Item>
          </Grid>
        ))}
      </Grid>

      {checkedState[2] ? (
        <Grid item xs={12} md={6} sx={{ mt: 3.5 }}>
          <TextField
            required
            id="EcommerceUrl"
            label="Ecommerce Url"
            fullWidth
            autoComplete="EcommerceUrl"
            variant="standard"
            value={planDetails.EcommerceUrl}
            onChange={(e) =>
              handleSetPlanDetails({
                ...planDetails,
                EcommerceUrl: e.target.value,
              })
            }
          />
        </Grid>
      ) : null}
    </React.Fragment>
  );
}
